export default __webpack_public_path__ + "static/media/grid-view-medium.77a36d32.svg";